<div class="form-input">
  @if (label) {
    <label [for]="idHTML">
      {{ label | transloco }}@if (isRequired) {
      <span>*</span>
    }
  </label>
}
<mat-form-field appearance="outline">
  <input
    matInput
    type="text"
    [id]="idHTML"
    [formControl]="_control"
    [attr.maxlength]="maxLength"
    [placeholder]="placeholder | transloco"/>
  @if (showCharCount && maxLength) {
    <mat-hint align="start">
      {{ charCount }} / {{ maxLength }}
    </mat-hint>
  }
  @if (_control.invalid) {
    <mat-error>
      {{ errorMessage | transloco: errorParams }}
    </mat-error>
  }
</mat-form-field>
</div>
